var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"flipInX"}},[_c('div',{staticClass:"settings-container"},[_c('div',{attrs:{"id":"logout"},on:{"click":_vm.logout}},[_c('font-awesome-icon',{attrs:{"icon":"sign-out-alt"}}),_vm._v(" Log out ")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }